import { render, staticRenderFns } from "./ActivitiesField.vue?vue&type=template&id=634b598a&scoped=true"
import script from "./ActivitiesField.vue?vue&type=script&lang=js"
export * from "./ActivitiesField.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesField.vue?vue&type=style&index=0&id=634b598a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b598a",
  null
  
)

export default component.exports